var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "input",
    attrs: {
      "empty-on-focus": "",
      fancy: _vm.fancy,
      label: _vm.label,
      items: _vm.filteredUsers,
    },
    on: {
      "item-click": function ($event) {
        return _vm.selectUser($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _c("div", [_vm._v(_vm._s(p.item.Email))]),
            _c("div", { staticClass: "smaller" }, [
              _vm._v(
                " " +
                  _vm._s(p.item.Firstname) +
                  " " +
                  _vm._s(p.item.Lastname) +
                  " "
              ),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }